var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tenancy-remarks__wrapper" },
    [
      _c(
        "Collapse",
        {
          staticClass:
            "tenancy-remarks__collapse small title-font14 title-responsive",
          attrs: {
            title: _vm.$t("common.remarks"),
            expand: true,
            withBorder: false,
            enableTransition: false,
          },
          on: { "expand-status": _vm.onExpand },
        },
        [
          _vm.showPreview
            ? _c(
                "template",
                { slot: "additional" },
                [
                  _c(
                    "a-row",
                    {
                      staticClass: "tenancy-remarks__preview",
                      attrs: { type: "flex", align: "bottom" },
                    },
                    [
                      _c("a-col", { staticClass: "tenancy-remarks__comment" }, [
                        _c("pre", {
                          domProps: {
                            innerHTML: _vm._s(_vm.previewRemark.comment),
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-col",
                        { staticClass: "tenancy-remarks__hint" },
                        [
                          _c("HKLGrayHint", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.previewRemark.confirmedByOn) +
                                "\n          "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "template",
            { slot: "content" },
            _vm._l(_vm.remarksList, function (item) {
              return _c(
                "a-row",
                {
                  key: item.id,
                  staticClass: "tenancy-remarks__item",
                  attrs: { type: "flex", align: "bottom" },
                },
                [
                  _c("a-col", { staticClass: "tenancy-remarks__comment" }, [
                    _c("pre", {
                      domProps: { innerHTML: _vm._s(item.comment) },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { staticClass: "tenancy-remarks__hint" },
                    [
                      _c("HKLGrayHint", [
                        _vm._v(
                          "\n            " +
                            _vm._s(item.confirmedByOn) +
                            "\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.hasUpdateRemarksAndDocsAccess
        ? _c(
            "a-row",
            { attrs: { type: "flex" } },
            [
              _c(
                "a-col",
                { attrs: { flex: "1" } },
                [
                  _c(
                    "HKLForm",
                    { ref: "remarksForm" },
                    [
                      _c("HKLTextareaVue", {
                        directives: [
                          {
                            name: "fusioninputcheck",
                            rawName: "v-fusioninputcheck",
                            value: {
                              required: true,
                            },
                            expression:
                              "{\n            required: true\n          }",
                          },
                        ],
                        staticClass: "tenancy-remarks__input",
                        model: {
                          value: _vm.remarks,
                          callback: function ($$v) {
                            _vm.remarks = $$v
                          },
                          expression: "remarks",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-col",
                [
                  _c("HKLButton", {
                    attrs: { action: "confirm", color: "orange" },
                    on: { click: _vm.confirm },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }